
<script>
    export let workRequest;
    let redirectUrl = `https://mobile.bhp.com/fiori#BHP_WMT_MAINTAIN-manageWorkOrder?ActiveMaintenanceOrder=${workRequest.number}&MaintenanceOrderDraftUUID=00000000-0000-0000-0000-000000000000`
</script>

<a href={redirectUrl} style="color: #dd5900;" target="_blank" rel="noopener noreferrer">
    {workRequest.number}
</a>